import styled from "@emotion/styled";

import { SkiliticsLogo, SvgInteractLogoTransparent } from "@skilitics/designer-theme";
import { Button, SkiliticsDots, type ButtonProps } from "@skilitics/designer-ui-components";

type Props = {
  label: string;
  busy?: boolean;
};

export const AuthHeader = ({ label, busy }: Props) => (
  <HeaderContainer>
    <Header>{label}</Header>
    <SkiliticsDots busy={busy} />
  </HeaderContainer>
);

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: 10px 0 20px;
`;

const Header = styled.h2`
  padding: 0;
  margin: 0;
  height: 48px; // Explicit height to prevent jumping when font is loaded.
  font-size: 48px;
  font-family: "hello-bloomie-script", sans-serif;
  font-weight: 400;
  line-height: 1;
  text-shadow: 0 4px 4px ${({ theme }) => theme.shadow};
  user-select: none;
`;

export const AuthLogo = () => (
  <LogoContainer>
    <Logo />
    <SkiliticsLogo width="100px" />
  </LogoContainer>
);

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.alwaysWhite};
`;
const Logo = styled(SvgInteractLogoTransparent)`
  width: 40px;
  margin-right: 5px;
`;

export const AuthButton = (props: ButtonProps) => <StyledButton {...props} />;

const StyledButton = styled(Button)`
  width: 100%;
  border-radius: 20px;
  font-size: inherit;
`;

export const termsOfUseLink = "//skilitics.com/legal/terms-of-service";
export const privacyPolicyLink = "//skilitics.com/legal/privacy-notice";

export const AuthFooter = () => (
  <Footer>
    <StyledLink href={termsOfUseLink} target="_blank" rel="noopener">
      Terms of Use
    </StyledLink>{" "}
    and{" "}
    <StyledLink href={privacyPolicyLink} target="_blank" rel="noopener">
      Privacy Policy
    </StyledLink>
    <FooterText>&copy; Copyright Skilitics LLC 2025</FooterText>
  </Footer>
);

const Footer = styled.footer`
  margin-top: 20px;
  padding-top: 15px;
  border-top: solid 1px ${({ theme }) => theme.outlineSoft};
  color: ${({ theme }) => theme.generalTextIconVariant};
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
`;

const StyledLink = styled.a`
  color: inherit;
  display: inline;
  width: 100%;
  text-align: center;
  padding: 0;
  margin: 0 0 10px;
`;

const FooterText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.generalTextIconVariant};
  text-align: center;
  padding: 0;
  margin: 0;
`;
